import { Link } from 'react-router-dom';
import { useApi } from '../hooks/useApi.js';
import { fetchAlumni } from '../lib/api.js';
import { Seo } from '../components/Seo.jsx';
import { PageHeader } from '../components/PageHeader.jsx';
import { usePage } from '../hooks/usePage.js';

const FALLBACK = [
  { id: 'a1', classOf: 'Class of 2018', name: 'Tahmid R.',  currentPath: 'Imperial College London — Engineering', quote: 'Maple Leaf taught me how to ask better questions. That habit carried me through Imperial.',                photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80' },
  { id: 'a2', classOf: 'Class of 2015', name: 'Nuzhat A.',  currentPath: 'McGill University — Medicine',          quote: "The teachers knew me. They pushed me. They never let me coast. I'm grateful every day.",                photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800&q=80' },
  { id: 'a3', classOf: 'Class of 2010', name: 'Rakibul H.', currentPath: 'Founder, fintech startup',              quote: 'Sports day, debate club, my first business idea — all of it started in those corridors.',                photo: 'https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=800&q=80' },
];

export function AlumniPage() {
  const head = usePage('alumni');
  const { data: alumni } = useApi(fetchAlumni, []);
  const list = (alumni && alumni.length ? alumni : FALLBACK);

  return (
    <>
      <Seo title="Alumni" description={head.metaDescription} />

      <PageHeader
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Alumni' }]}
        headline={head.headline}
        lede={head.lede}
        image={head.banner}
      />

      <section>
        <div className="container">
          <div className="msg-grid">
            {list.map((a) => (
              <div className="msg-card" key={a.id}>
                <div className="photo" style={{ backgroundImage: `url('${a.photo || ''}')` }} />
                <div className="body">
                  {a.classOf && <span className="label">{a.classOf}</span>}
                  <span className="name">{a.name}</span>
                  {a.currentPath && <span className="role">{a.currentPath}</span>}
                  {a.quote && <p>"{a.quote}"</p>}
                </div>
              </div>
            ))}
          </div>

          {/* "Stay connected" CTA — matches design alumni.html lines 18-22 */}
          <div style={{ marginTop: 64, padding: 48, background: 'var(--cream)', textAlign: 'center' }}>
            <h2 className="section-title" style={{ margin: '0 auto 12px' }}>Stay connected</h2>
            <p style={{ maxWidth: '50ch', margin: '0 auto 28px' }}>
              Update your details and join the alumni network for events, mentoring opportunities and reunions.
            </p>
            <Link to="/alumni/register" className="btn btn-primary">Register as alumni</Link>
          </div>
        </div>
      </section>
    </>
  );
}
